

import Create from "./component/create"
import Header from "./component/header"


function BackCreate(){


    return(
       <>
         <Header/>

        <Create/>

       
       </>
    )
}

export default BackCreate